import React from 'react';
import PropTypes from 'prop-types';

import Button from '@Components/Button';

function RsSlidableNavigationNext({ disabled, onClick }) {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      buttonConfig={{
        className: 'rs-slidable-navigation__button',
        type: 'link',
        size: 'sm',
        iconOnly: true,
        ariaLabel: 'Slide next',
        e2eName: 'slide-right',
      }}
      iconConfig={{ name: 'chevron-right', size: 'sm' }}
    />
  );
}

RsSlidableNavigationNext.defaultProps = {
  onClick: () => {},
};

RsSlidableNavigationNext.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

export default RsSlidableNavigationNext;
